export default "__VITE_ASSET__DAcbCiIu__"